/**
 * The morning routine — five presses, read by chapter 9's beats and its
 * self-pressing checklist so the two can never disagree.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { CountryTab } from '@/pages/admin/drop-generator/CountryTabs';

export interface MorningStep {
  time: string;
  where: string;
  action: string;
  /** Where the press lands in the app; null = the Prepared Drops page. */
  tab: CountryTab | null;
}

export const MORNING_STEPS: MorningStep[] = [
  { time: '08:00', where: 'Auto-generate', action: 'the drops generate themselves, texts fill in — or you press Generate now', tab: 'board' },
  { time: '10:55', where: 'Board', action: 'is everything green?', tab: 'board' },
  { time: '10:56', where: 'Day timeline', action: 'read the day, skip what you do not want', tab: 'timeline' },
  { time: '11:00', where: 'Prepared Drops', action: 'you send — or, in the campaign groups with Auto-send on, the engine sends each draft at its time', tab: null },
  { time: '15:15', where: 'Live', action: 'verdicts and the stop-loss judged every 15 minutes — see who passed', tab: 'live' },
];
